import {Component, Input, Output, EventEmitter} from '@angular/core';
import {NgForOf, NgClass} from '@angular/common';
import {SquareButtonComponent} from '../square-button/square-button.component';

interface SelectableTopAction {
  label: string;
  labelSuffix?: string;
  href: string;
  action?: string;
  selected?: boolean;
}

@Component({
  selector: 'selectable-menu-buttons',
  templateUrl: './selectable-menu-buttons.component.html',
  styleUrls: ['./selectable-menu-buttons.component.scss'],
  imports: [SquareButtonComponent, NgForOf, NgClass],
  standalone: true
})
export class SelectableMenuButtonsComponent {

  @Input() topActions: SelectableTopAction[] = [];
  @Input() selectedAction: any = null;
  @Output() actionClick = new EventEmitter<any>();
  @Output() selectionChange = new EventEmitter<SelectableTopAction | SelectableTopAction[]>();

  constructor() {
  }

  onActionClick(action: SelectableTopAction, event: Event) {
    event.preventDefault();
    this.topActions.forEach(a => a.selected = false);
    action.selected = true;
    this.selectedAction = action;
    this.selectionChange.emit(action);
    this.actionClick.emit(action);
  }

  isSelected(action: SelectableTopAction): boolean {
    return action.selected || false;
  }

  clearSelection(): void {
    this.topActions.forEach(action => action.selected = false);
    this.selectedAction = null;
    this.selectionChange.emit();

  }


  selectAction(actionToSelect: SelectableTopAction) {
    const foundAction = this.topActions.find(a => a.href === actionToSelect.href);
    if (foundAction) {
      foundAction.selected = true;
    }
  }
}
